import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { AuthHttp } from "angular2-jwt";
import { EcMotif } from "../classes/motif";
import { Statique } from "../utils/statique";


@Injectable()
export class MotifService {
    
    constructor(private http: Http, private authHttp: AuthHttp) { }

    ajouterEcMotif(ecMotif:EcMotif) {
		return this.authHttp
			.post(Statique.controllerMotif+ "/add", ecMotif)
			.map((res) => res.json());
    }
    listMotif() {
		return this.authHttp
			.get(Statique.controllerMotif + "/listMotif")
			.map((res) => res.json());
	}

}


// WEBPACK FOOTER //
// ./src/app/services/motif.service.ts